import React, { useEffect, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { useAppContext } from "providers/AppProvider";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Gear } from "react-bootstrap-icons";

import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import useAdvanceTable from "hooks/useAdvanceTable";
import FalconPagination from "components/common/custom/pagination";
import SubtleBadge from "components/common/SubtleBadge";
import CardDropdown from "components/common/CardDropdown";
import PrintComponent from "components/common/custom/print/PrintComponents";
import BenefitsTable from "helpers/print/BenefitsTable/BenefitsTable";
import DCAF from "helpers/print/DCAF/DCAF";
import OCAF from "helpers/print/OCAF/OCAF";
import UCAF from "helpers/print/UCAF/UCAF";
import paths from "routes/paths";
import {
  GetRequestJSONData,
  GetResponseJSONData,
  GetSingleEligibilityData,
} from "../config/eligibilityCheckListApi";
import { saveAs } from "file-saver";
const EligibilityCheckListTable = ({
  handlePerRowsChange,
  handlePageChange,
  totalRows,
  data,
  page,
  rowsPerPage,
}) => {
  const { getThemeColor } = useAppContext();
  const dispatch = useDispatch();
  const { allPermissionType } = useSelector((state) => state.role);
  const eligibilitySetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Eligibility",
  );

  console.log({ eligibilitySetting });

  const { userData } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [showOCAF, setShowOCAF] = useState(false);
  const [showDCAF, setShowDCAF] = useState(false);
  const [showBenefitsTable, setShowBenefitsTable] = useState(false);

  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "payer_name",
      header: "Payer",
      cell: ({ row: { original } }) => (
        <div className="fs-11 w-100 ">
          {original.insurance_direct === 1
            ? original.payer_name || "-"
            : `${original.payer_name || "-"} - ${
                original.insurance_shname || ""
              }`}
        </div>
      ),
    },

    {
      accessorKey: "eligibility_checks_id",
      header: "Eligibility ID",
      cell: ({ row: { original } }) => (
        <div className="fs-11 w-100 ">
          {original.eligibility_checks_id || ""}
        </div>
      ),
    },
    {
      accessorKey: "created_at",
      header: "Date",
      cell: ({ row: { original } }) => (
        <div className="fs-11 w-100">
          {moment(original.created_at).format("DD-MM-YYYY , hh:mm:ss A") || "-"}
        </div>
      ),
    },
    {
      accessorKey: "policy_holder",
      header: "Policy Header",
      cell: ({ row: { original } }) => (
        <div className="d-flex flex-column justify-content-center w-100 fs-11">
          <div className="">{original.policy_holder || "-"}</div>
          {original.class_name && (
            <div className="d-flex  align-items-center gap-1">
              <span className="text-success">Class -</span>
              <span>{original.class_name}</span>
            </div>
          )}
        </div>
      ),
    },
    {
      accessorKey: "patient",
      header: "Patient",
      cell: ({ row: { original } }) => (
        <div className="d-flex flex-column w-100">
          <div className="fs-11 text-700">
            {`${original.eligibility_checks_patientfirstname} ${original.eligibility_checks_patientfamilyname}`}
          </div>
          <div className="text-500 fs-11">
            {original?.patient_identifier
              ? `${original?.patient_identifier} - `
              : ""}{" "}
            {original.eligibility_checks_patientiqama}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "eligibility_checks_status",
      header: "Status",
      cell: ({ row: { original } }) => {
        const rawStatus = original.eligibility_checks_status || "";
        const normalizedStatus = rawStatus.replace(/\s+/g, "").toLowerCase();

        const statusConfig = {
          eligible: {
            bg: "#d9f8eb",
            color: "#00894f",
            icon: "check",
            label: "Eligible",
          },
          noresponse: {
            bg: "#91979e",
            color: "#08101b",
            icon: "times",
            label: "No Response",
          },
          invalid: {
            bg: "#fde6d8",
            color: "#ac5a2b",
            icon: "times",
            label: "InValid",
          },
          error: {
            bg: "#b82c46",
            color: "#fbdbe1",
            icon: "exclamation",
            label: "Error",
          },
          ineligible: {
            color: "#b82c46",
            bg: "#fbdbe1",
            icon: "exclamation",
            label: "InEligibile",
          },
        };

        const config = statusConfig[normalizedStatus] || {
          bg: "#f8f9fa",
          color: "#000",
          icon: "question",
          label: rawStatus || "Unknown",
        };

        return (
          <div className="d-flex justify-content-start w-100">
            <SubtleBadge
              pill
              style={{
                backgroundColor: config.bg,
                color: config.color,
                border: `1px solid ${config.color}20`,
                width: "110px",
              }}
              className="d-flex flex-center fs-12 p-2 gap-1"
            >
              <FontAwesomeIcon
                icon={config.icon}
                transform="shrink-2"
                className="ms-1 me-1"
              />
              {config.label}
            </SubtleBadge>
          </div>
        );
      },
    },

    {
      accessorKey: "requested_by",
      header: "Requested By",
      cell: ({ row: { original } }) => (
        <div className="fs-11 w-100">
          {`${original.employees_firstname || ""} ${original.employees_familyname || ""}`}
        </div>
      ),
    },
    {
      accessorKey: "actions",
      header: <Gear />,
      enableSorting: false,
      cell: ({ row: { original } }) => {
        const handleViewEligibilityData = (id) => {
          navigate(`${paths.eligibilityCheck}/${id}`);
        };

        const handlePrintUCAF = async (id) => {
          const response = await dispatch(
            GetSingleEligibilityData(id),
          ).unwrap();

          if (response?.success) {
            setShow(true);
            setPrintData(response?.data);
          }
        };

        const handlePrintOCAF = async (id) => {
          const response = await dispatch(
            GetSingleEligibilityData(id),
          ).unwrap();

          if (response?.success) {
            setShowOCAF(true);
            setPrintData(response?.data);
          }
        };
        const handlePrintDCAF = async (id) => {
          const response = await dispatch(
            GetSingleEligibilityData(id),
          ).unwrap();

          if (response?.success) {
            setShowDCAF(true);
            setPrintData(response?.data);
          }
        };

        const handlePrintBenefitsTable = async (id) => {
          const response = await dispatch(
            GetSingleEligibilityData(id),
          ).unwrap();

          if (response?.success) {
            setShowBenefitsTable(true);
            setPrintData(response?.data);
          }
        };

        const handleDownloadRequestJson = async (id) => {
          try {
            // Step 1: Dispatch the API call
            const response = await dispatch(GetRequestJSONData(id)).unwrap();
            const downloadUrl = response?.data?.request_file;

            if (!downloadUrl) {
              throw new Error("Download URL not found.");
            }

            // Step 2: Fetch the file from the download URL
            const fileResponse = await fetch(downloadUrl);

            if (!fileResponse.ok) {
              throw new Error("Failed to fetch the JSON file.");
            }

            const blob = await fileResponse.blob();

            // Step 3: Extract the filename from the URL
            const urlParts = downloadUrl.split("/");
            const filename = urlParts[urlParts.length - 1] || "downloaded.json";

            // Step 4: Save the blob as a file
            saveAs(blob, filename);
          } catch (error) {
            console.error("Error downloading the JSON file:", error);
          }
        };
        const handleDownloadResponseJson = async (id) => {
          try {
            // Step 1: Dispatch the API call
            const response = await dispatch(GetResponseJSONData(id)).unwrap();
            const downloadUrl = response?.data?.response_file;

            if (!downloadUrl) {
              throw new Error("Download URL not found.");
            }

            // Step 2: Fetch the file from the download URL
            const fileResponse = await fetch(downloadUrl);

            if (!fileResponse.ok) {
              throw new Error("Failed to fetch the JSON file.");
            }

            const blob = await fileResponse.blob();

            // Step 3: Extract the filename from the URL
            const urlParts = downloadUrl.split("/");
            const filename = urlParts[urlParts.length - 1] || "downloaded.json";

            // Step 4: Save the blob as a file
            saveAs(blob, filename);
          } catch (error) {
            console.error("Error downloading the JSON file:", error);
          }
        };

        const handleSubmitPreauthorization = async (id, route) => {
          const response = await dispatch(
            GetSingleEligibilityData(id),
          ).unwrap();
          if (response?.success) {
            navigate(
              `${paths.preauthorization}?preauthid=${route}&eligibility=true`,
            );
          } else {
            toast.error("Something went wrong");
          }
        };
        const handleSubmitClaim = async (id, route) => {
          const response = await dispatch(
            GetSingleEligibilityData(id),
          ).unwrap();
          if (response?.success) {
            navigate(
              `${paths.createClaim}?eligibilityID=${route}&eligibility=true`,
            );
          } else {
            toast.error("Something went wrong");
          }
        };

        return (
          <>
            <CardDropdown icon="ellipsis-v" dropdownClassName="py-2">
              {Number(eligibilitySetting?.view) === 1 && (
                <Dropdown.Item
                  onClick={() =>
                    handleViewEligibilityData(original?.eligibilityid)
                  }
                >
                  <FontAwesomeIcon icon="eye" className="me-2" />
                  View Details
                </Dropdown.Item>
              )}
              {Number(eligibilitySetting?.submit) === 1 &&
                original?.eligibility_checks_status?.toLowerCase() ===
                  "eligible" && (
                  <Dropdown.Item
                    onClick={() =>
                      handleSubmitPreauthorization(
                        original?.eligibilityid,
                        original?.eligibility_checks_id,
                      )
                    }
                  >
                    <FontAwesomeIcon icon="paper-plane" className="me-2" />
                    Submit Preauthorization
                  </Dropdown.Item>
                )}
              {Number(eligibilitySetting?.submit) === 1 &&
                original?.eligibility_checks_status?.toLowerCase() ===
                  "eligible" && (
                  <Dropdown.Item
                    onClick={() =>
                      handleSubmitClaim(
                        original?.eligibilityid,
                        original?.eligibility_checks_id,
                      )
                    }
                  >
                    <FontAwesomeIcon icon="paper-plane" className="me-2" />
                    Submit Claim
                  </Dropdown.Item>
                )}
              {Number(eligibilitySetting?.print) === 1 && (
                <>
                  <Dropdown.Item
                    onClick={() => handlePrintUCAF(original?.eligibilityid)}
                  >
                    <FontAwesomeIcon icon="print" className="me-2" />
                    Print UCAF
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handlePrintOCAF(original?.eligibilityid)}
                  >
                    <FontAwesomeIcon icon="print" className="me-2" />
                    Print OCAF
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handlePrintDCAF(original?.eligibilityid)}
                  >
                    <FontAwesomeIcon icon="print" className="me-2" />
                    Print DCAF
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      handlePrintBenefitsTable(original?.eligibilityid)
                    }
                  >
                    <FontAwesomeIcon icon="print" className="me-2" />
                    Print Benefits
                  </Dropdown.Item>
                </>
              )}
              {Number(eligibilitySetting?.export) === 1 && (
                <>
                  <Dropdown.Item
                    onClick={() =>
                      handleDownloadRequestJson(original?.eligibilityid)
                    }
                  >
                    <FontAwesomeIcon icon="download" className="me-2" />
                    Download JSON Request
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      handleDownloadResponseJson(original?.eligibilityid)
                    }
                  >
                    <FontAwesomeIcon icon="download" className="me-2" />
                    Download JSON Response
                  </Dropdown.Item>
                </>
              )}
            </CardDropdown>
          </>
        );
      },
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);

  return (
    <div className="mb-3 mt-3 border">
      {Number(eligibilitySetting?.list) === 1 ? (
        data?.length > 0 ? (
          <>
            <AdvanceTableProvider {...table}>
              <AdvanceTable
                tableProps={{
                  size: "sm",
                  className: "fs-10 mb-0 overflow-hidden",
                  striped: true,
                }}
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
              />
            </AdvanceTableProvider>
            <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
              <FalconPagination
                currentPage={page}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRows}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePerRowsChange}
              />
            </Card.Footer>
          </>
        ) : (
          <div className="text-center py-3">No Data To Show</div>
        )
      ) : (
        <div className="text-center py-3 ">
          <h5 className="text-danger mt-3">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view this list.
          </p>
        </div>
      )}

      {show && (
        <PrintComponent
          text={""}
          onPrintOpen={() => {
            setShow(false);
            // setPrintableObj(null);
          }}
          child={
            <UCAF
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}
      {showOCAF && (
        <PrintComponent
          text={""}
          onPrintOpen={() => {
            setShowOCAF(false);
            // setPrintData(null);
          }}
          child={
            <OCAF
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}

      {showDCAF && (
        <PrintComponent
          text={""}
          onPrintOpen={() => {
            setShowDCAF(false);
            // setPrintData(null);
          }}
          child={
            <DCAF
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}

      {showBenefitsTable && (
        <PrintComponent
          text={""}
          onPrintOpen={() => {
            setShowBenefitsTable(false);
          }}
          child={
            <BenefitsTable
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}
    </div>
  );
};

export default EligibilityCheckListTable;
